define("analytics-resources/types/chart-types", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TimeScale = _exports.TIMESERIES_TYPES = _exports.DisplayFormat = _exports.ChartUnits = _exports.ChartState = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  let DisplayFormat = _exports.DisplayFormat = /*#__PURE__*/function (DisplayFormat) {
    DisplayFormat["Average"] = "average";
    DisplayFormat["Total"] = "total";
    DisplayFormat["Value"] = "value";
    return DisplayFormat;
  }({});
  let ChartUnits = _exports.ChartUnits = /*#__PURE__*/function (ChartUnits) {
    ChartUnits["Percent"] = "%";
    ChartUnits["Hours"] = "h";
    ChartUnits["Days"] = "d";
    ChartUnits["None"] = "";
    return ChartUnits;
  }({});
  let ChartState = _exports.ChartState = /*#__PURE__*/function (ChartState) {
    ChartState["Loading"] = "loading";
    ChartState["Error"] = "error";
    ChartState["NoData"] = "no-data";
    ChartState["PartialData"] = "partial-data";
    ChartState["Data"] = "data";
    ChartState["RefreshProfile"] = "refresh-profile";
    ChartState["Backfilling"] = "backfilling";
    return ChartState;
  }({});
  let TimeScale = _exports.TimeScale = /*#__PURE__*/function (TimeScale) {
    TimeScale["Week"] = "week";
    TimeScale["Day"] = "day";
    TimeScale["Hour"] = "hour";
    return TimeScale;
  }({});
  const TIMESERIES_TYPES = _exports.TIMESERIES_TYPES = {
    AREASPLINE: 'areaspline',
    SPLINE: 'spline'
  };
});